export const SETUP_NEW_PASSWORD = "SETUP_NEW_PASSWORD"
export const SETUP_NEW_PASSWORD_SUCCESS = "SETUP_NEW_PASSWORD_SUCCESS"
export const SETUP_NEW_PASSWORD_ERROR = "SETUP_NEW_PASSWORD_ERROR"